import * as Yup from "yup";

import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from "@material-ui/core";
import { Field, Form, Formik } from "formik";
import {
  createPortAuthorityPrfcs,
  deletePortAuthorityPrfcsByPrfIdAndPauthId,
  fetchPrfcsForPortAuthority
} from "../../../../services/portAuthorityPrfcsService";
import { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";

import CustomAlert from "../../../components/CustomAlert";
import { Autocomplete as FormikAutocomplete } from 'formik-material-ui-lab';
import { createPortAuthority } from "../../../../services/portAuthoritiesService";
import { fetchPrfcs } from '../../../../services/prfcsService'
import useLocale from "../../../../hooks/useLocale";

const UpdatePortAuthorityMunicipalityForm = ({ setFieldValue, errors, touched, values, selectedItem }) => {
  const [error, setError] = useState("");
  const [addSuccess, setAddSuccess] = useState("");
  const [removeSuccess, setRemoveSuccess] = useState("");
  const { t } = useLocale();
  const { data: prfcs } = useQuery('prfcs', fetchPrfcs);
  const { data: portAuthprfcs } = useQuery(['portAuthprfcs', selectedItem?.id], () => fetchPrfcsForPortAuthority(selectedItem?.id));
  const [selectedItems, setSelectedItems] = useState([]);

  const { mutate: addPortAuthPrfcMutation } = useMutation(createPortAuthorityPrfcs, {
    onSuccess: (data, variables) => {
      setAddSuccess(t("Municipality added successfully to Port Authority"));
      setTimeout(() => setAddSuccess(''), 2000);
      setSelectedItems(variables.newValue);
      setFieldValue("prf_id", selectedItems)
    },
    onError: (error) => {
      switch (error) {
        default: {
          setError(t("A network error occured. Please try again later"));
        }
      }
    },
  });

  const { mutate: removePortAuthPrfcMutation } = useMutation(deletePortAuthorityPrfcsByPrfIdAndPauthId, {
    onSuccess: (data, variables) => {
      setRemoveSuccess(t("Municipality removed successfully from Port Authority"));
      setTimeout(() => setRemoveSuccess(''), 2000);
      setSelectedItems(variables.newValue);
      setFieldValue("prf_id", selectedItems)
    },
    onError: (error) => {
      switch (error) {
        default: {
          setError(t("A network error occured. Please try again later"));
        }
      }
    },
  });

  useEffect(() => {
    setSelectedItems(prfcs?.filter(prf => {
      return portAuthprfcs?.filter(pap => {
        return pap?.prf_id === prf?.id
      })?.length !== 0
    }))


  }, [prfcs, portAuthprfcs])

  //uses add mutation to add prf to port authority gets prfId and the new Array of prfs as params
  const addPrfcToPortAuthority = (prfId, newValue) => {
    const valuesToSubmit = {
      prf_id: prfId,
      pauth_id: selectedItem.id
    }
    addPortAuthPrfcMutation({ items: JSON.stringify([valuesToSubmit]), newValue: newValue });
  }

  //uses remove mutation to remove prf from port authority gets prfId and the new Array of prfs as params
  const removePrfcFromPortAuthority = (prfId, newValue) => {
    const valuesToSubmit = {
      prf_id: prfId,
      pauth_id: selectedItem.id
    }
    removePortAuthPrfcMutation({ items: JSON.stringify([valuesToSubmit]), newValue: newValue });
  }

  return (
    <>
      <DialogContent>
        <DialogContentText>
          {t("Fill in the form below and click on Add to add a new Municipalities to Port Authority")}
        </DialogContentText>
      </DialogContent>
      <CustomAlert
        open={!!error}
        close={() => {
          setError("");
        }}
        message={t("A network error occured, please try again later")}
      />
      <CustomAlert
        open={!!addSuccess}
        close={() => {
          setAddSuccess("");
        }}
        message={t("Municipality added successfully to Port Authority")}
        severity={"success"}
      />
      <CustomAlert
        open={!!removeSuccess}
        close={() => {
          setRemoveSuccess("");
        }}
        message={t("Municipality removed successfully from Port Authority")}
        severity={"success"}
      />
      <DialogContent>
        <Field
          key={selectedItems || []}
          multiple
          disableClearable
          defaultValue={selectedItems || []}
          name='prf_id_select'
          component={FormikAutocomplete}
          //filterOptions
          onChange={(event, newValue, reason) => {
            if (reason === 'select-option') {
              addPrfcToPortAuthority(newValue[selectedItems?.length]?.id, newValue);
            } else if (reason === 'remove-option') {
              let missing = selectedItems?.filter((i => a => a !== newValue[i] || !++i)(0));
              removePrfcFromPortAuthority(missing[0]?.id, newValue)
            }
          }}
          options={prfcs || []}
          getOptionLabel={(options) => options?.dscr}
          renderInput={(params) => (
            <TextField
              {...params}
              name='prf_id'
              error={touched['prf_id'] && !!errors['prf_id']}
              helperText={touched['prf_id'] && errors['prf_id']}
              label={t('Municipality / Geographical Department')}
              variant="outlined"
              margin='normal'
            />
          )}
        />
      </DialogContent>
    </>
  );
};

export default UpdatePortAuthorityMunicipalityForm;
